// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class ListView extends JQueryView {
  constructor() {
    super('.documents-table');
  }

  @on({ event: 'click', selector: 'tr[data-href]' })
  onClickTr(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;

    const documentType = $(e.currentTarget).data('documentType');
    const isReviewDocument = $(e.currentTarget).data('isReviewDocument');

    if (documentType === 'Company::Document::Folder' || isReviewDocument) {
      window.location = $(e.currentTarget).data('href');
    } else if (documentType === 'Company::Document::File') {
      window.open(
        $(e.currentTarget).data('href'),
        '_blank',
        'noopener',
        'noreferrer',
      );
    }
  }
}
